import React from 'react';
import { StepProps } from '../../types';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { Button } from '../ui/Button';
import { Select } from '../ui/Select'; 


export const Step6OtherAdjustments: React.FC<StepProps> = ({ formData, onChange, errors, t, openScheduleModal }) => {
  const data = formData.otherAdjustments;

  const priorTaxPeriodOptions = [
    {value: '', label: t('select_option')},
    {value: '2023', label: '2023'},
    {value: '2022', label: '2022'},
  ];

  const handlePriorPeriodTaxPeriodsChange = (selectedOptions: string[]) => {
    onChange('otherAdjustments', 'priorPeriodErrorAdjustmentsTaxPeriods', selectedOptions);
  };


  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-[#1a2c46] mb-6">{t('step6_title')}</h2>

      <fieldset className="p-4 border rounded-md bg-slate-50">
        <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s9_1_non_deductible_title')}</legend>
        <Input
          label={t('s9_1_entertainment_exp_label')}
          type="number"
          id="nonDeductibleEntertainmentExp"
          value={data.nonDeductibleEntertainmentExp}
          onChange={(e) => onChange('otherAdjustments', 'nonDeductibleEntertainmentExp', e.target.value)}
          error={errors.nonDeductibleEntertainmentExp as string}
          placeholder={t('amount_aed_placeholder')}
          helpText={t('s9_1_entertainment_exp_help')}
        />
        <Input
          label={t('s9_1_pension_contributions_label')}
          type="number"
          id="nonDeductiblePensionContributions"
          value={data.nonDeductiblePensionContributions}
          onChange={(e) => onChange('otherAdjustments', 'nonDeductiblePensionContributions', e.target.value)}
          error={errors.nonDeductiblePensionContributions as string}
          placeholder={t('amount_aed_placeholder')}
        />
        <Input
          label={t('s9_1_charitable_donations_label')}
          type="number"
          id="nonDeductibleCharitableDonationsNonQPBE"
          value={data.nonDeductibleCharitableDonationsNonQPBE}
          onChange={(e) => onChange('otherAdjustments', 'nonDeductibleCharitableDonationsNonQPBE', e.target.value)}
          error={errors.nonDeductibleCharitableDonationsNonQPBE as string}
          placeholder={t('amount_aed_placeholder')}
        />
        <Input
            label={t('s9_1_exp_exempt_income_label')}
            type="number"
            id="expenditureDerivingExemptIncomeNonInterest"
            value={data.expenditureDerivingExemptIncomeNonInterest}
            onChange={(e) => onChange('otherAdjustments', 'expenditureDerivingExemptIncomeNonInterest', e.target.value)}
            error={errors.expenditureDerivingExemptIncomeNonInterest as string}
            placeholder={t('amount_aed_placeholder')}
        />
        <Input
            label={t('s9_1_owner_dividends_expensed_label')}
            type="number"
            id="ownerDividendsExpensed"
            value={data.ownerDividendsExpensed}
            onChange={(e) => onChange('otherAdjustments', 'ownerDividendsExpensed', e.target.value)}
            error={errors.ownerDividendsExpensed as string}
            placeholder={t('amount_aed_placeholder')}
        />
        {formData.taxablePersonDetails.filingAs === 'natural_person' && (
            <Input
                label={t('s9_1_natural_person_withdrawals_label')}
                type="number"
                id="naturalPersonWithdrawals"
                value={data.naturalPersonWithdrawals}
                onChange={(e) => onChange('otherAdjustments', 'naturalPersonWithdrawals', e.target.value)}
                error={errors.naturalPersonWithdrawals as string}
                placeholder={t('amount_aed_placeholder')}
            />
        )}
        <Input
            label={t('s9_1_expenses_not_wholly_exclusively_label')}
            type="number"
            id="expensesNotWhollyExclusivelyBusiness"
            value={data.expensesNotWhollyExclusivelyBusiness}
            onChange={(e) => onChange('otherAdjustments', 'expensesNotWhollyExclusivelyBusiness', e.target.value)}
            error={errors.expensesNotWhollyExclusivelyBusiness as string}
            placeholder={t('amount_aed_placeholder')}
        />
        <Input
            label={t('s9_1_other_non_deductible_label')}
            type="number"
            id="otherNonDeductibleExpenditure"
            value={data.otherNonDeductibleExpenditure}
            onChange={(e) => onChange('otherAdjustments', 'otherNonDeductibleExpenditure', e.target.value)}
            error={errors.otherNonDeductibleExpenditure as string}
            placeholder={t('amount_aed_placeholder')}
        />
        <Input
            label={t('s9_1_other_non_deductible_desc_label')}
            type="text"
            id="otherNonDeductibleExpenditureDesc"
            value={data.otherNonDeductibleExpenditureDesc}
            onChange={(e) => onChange('otherAdjustments', 'otherNonDeductibleExpenditureDesc', e.target.value)}
            error={errors.otherNonDeductibleExpenditureDesc as string}
            placeholder="Specify details"
        />
      </fieldset>

      <fieldset className="p-4 border rounded-md bg-slate-50">
        <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s9_2_interest_exp_title')}</legend>
        <RadioGroup
          label={t('s9_2_net_interest_exceeds_threshold_label')}
          name="netInterestExpExceedsThreshold"
          value={data.netInterestExpExceedsThreshold}
          onChange={(val) => onChange('otherAdjustments', 'netInterestExpExceedsThreshold', val)}
          options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
          error={errors.netInterestExpExceedsThreshold as string}
          t={t}
          helpText={t('alert_nie_sch19_threshold')}
        />
        {data.netInterestExpExceedsThreshold === 'yes' && openScheduleModal && (
             <Button
                type="button"
                onClick={() => openScheduleModal('schedule19InterestCapping', formData.schedule19InterestCapping)}
                variant="secondary"
                className="mt-2 mb-2 text-sm"
              >
                {t('open_schedule_button', {schedule_name: t('schedule19_title')})}
              </Button>
        )}
        <Input
            label={t('s9_2_disallowed_net_interest_label')}
            type="text"
            id="disallowedNetInterestExpCurrentPeriod"
            value={data.disallowedNetInterestExpCurrentPeriod}
            readOnly
            className="bg-gray-100"
            error={errors.disallowedNetInterestExpCurrentPeriod as string}
            placeholder={t('amount_aed_placeholder')}
            helpText={t('s9_2_disallowed_net_interest_help')}
        />
         <Input
            label={t('s9_2_brought_forward_nie_utilised_label')}
            type="text"
            id="broughtForwardNieUtilised"
            value={data.broughtForwardNieUtilised}
            readOnly
            className="bg-gray-100"
            error={errors.broughtForwardNieUtilised as string}
            placeholder={t('amount_aed_placeholder')}
        />
        {formData.taxablePersonDetails.filingAs === 'tax_group_parent' && (
             <Input label={t('s9_2_pre_grouping_nie_tax_groups_label')} type="text" id="preGroupingNIETaxGroups" value={data.preGroupingNIETaxGroups || '0.00'} readOnly className="bg-gray-100" error={errors.preGroupingNIETaxGroups as string} placeholder={t('amount_aed_placeholder')} />
        )}
         <Input
            label={t('s9_2_specific_interest_non_deductible_label')}
            type="number"
            id="specificInterestNonDeductible"
            value={data.specificInterestNonDeductible}
            onChange={(e) => onChange('otherAdjustments', 'specificInterestNonDeductible', e.target.value)}
            error={errors.specificInterestNonDeductible as string}
            placeholder={t('amount_aed_placeholder')}
        />
      </fieldset>

      <fieldset className="p-4 border rounded-md bg-slate-50">
        <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s9_3_related_connected_title')}</legend>
        <RadioGroup
          label={t('s9_3_related_party_transactions_exist_label')}
          name="relatedPartyTransactionsExist"
          value={data.relatedPartyTransactionsExist}
          onChange={(val) => onChange('otherAdjustments', 'relatedPartyTransactionsExist', val)}
          options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
          error={errors.relatedPartyTransactionsExist as string}
          t={t}
        />
        {data.relatedPartyTransactionsExist === 'yes' && (
          <>
            <RadioGroup
              label={t('s9_3_related_party_aggregate_exceeds_40m_label')}
              name="relatedPartyTransactionsAggregateValueExceeds40M"
              value={data.relatedPartyTransactionsAggregateValueExceeds40M || ''}
              onChange={(val) => onChange('otherAdjustments', 'relatedPartyTransactionsAggregateValueExceeds40M', val)}
              options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
              t={t}
              helpText={t('alert_rp_sch16_1_threshold')}
            />
            {data.relatedPartyTransactionsAggregateValueExceeds40M === 'yes' && openScheduleModal && (
              <Button type="button" onClick={() => openScheduleModal('schedule16RelatedParty', formData.schedule16RelatedParty)} variant="secondary" className="my-2 text-sm">
                {t('open_schedule_button', {schedule_name: t('sch16_1_title')})}
              </Button>
            )}
            <Input
              label={t('s9_3_additions_armslength_label')}
              type="text"
              id="additionsArmslengthAdjustments"
              value={data.additionsArmslengthAdjustments}
              readOnly
              className="bg-gray-100"
              error={errors.additionsArmslengthAdjustments as string}
              placeholder={t('amount_aed_placeholder')}
              helpText={t('s9_3_additions_armslength_help')}
            />
            <Input label={t('s9_3_deductions_armslength_label')} type="text" id="deductionsArmslengthAdjustments" value={data.deductionsArmslengthAdjustments || '0.00'} readOnly className="bg-gray-100" error={errors.deductionsArmslengthAdjustments as string} placeholder={t('amount_aed_placeholder')} />
          </>
        )}
        <RadioGroup
            label={t('s9_3_rp_asset_gain_loss_realised_label')}
            name="relatedPartyAssetGainLossRealised"
            value={data.relatedPartyAssetGainLossRealised}
            onChange={(val) => onChange('otherAdjustments', 'relatedPartyAssetGainLossRealised', val)}
            options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
            error={errors.relatedPartyAssetGainLossRealised as string}
            t={t}
        />
        {data.relatedPartyAssetGainLossRealised === 'yes' && (
            <>
            <Input label={t('s9_3_rp_asset_gain_label')} type="number" id="relatedPartyAssetGain" value={data.relatedPartyAssetGain} onChange={(e) => onChange('otherAdjustments', 'relatedPartyAssetGain', e.target.value)} error={errors.relatedPartyAssetGain as string} placeholder={t('amount_aed_placeholder')} />
            <Input label={t('s9_3_rp_asset_loss_label')} type="number" id="relatedPartyAssetLoss" value={data.relatedPartyAssetLoss} onChange={(e) => onChange('otherAdjustments', 'relatedPartyAssetLoss', e.target.value)} error={errors.relatedPartyAssetLoss as string} placeholder={t('amount_aed_placeholder')} />
            </>
        )}
        <div className="mt-4">
            <RadioGroup
            label={t('s9_3_connected_persons_transactions_exist_label')}
            name="connectedPersonsTransactionsExist"
            value={data.connectedPersonsTransactionsExist}
            onChange={(val) => onChange('otherAdjustments', 'connectedPersonsTransactionsExist', val)}
            options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
            error={errors.connectedPersonsTransactionsExist as string}
            t={t}
            />
        </div>
        {data.connectedPersonsTransactionsExist === 'yes' && (
            <>
              <RadioGroup
                label={t('s9_3_connected_persons_aggregate_exceeds_500k_label')}
                name="connectedPersonsPaymentsAggregateValueExceeds500K"
                value={data.connectedPersonsPaymentsAggregateValueExceeds500K || ''}
                onChange={(val) => onChange('otherAdjustments', 'connectedPersonsPaymentsAggregateValueExceeds500K', val)}
                options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
                t={t}
                helpText={t('alert_cp_sch16_2_threshold')}
              />
              {data.connectedPersonsPaymentsAggregateValueExceeds500K === 'yes' && openScheduleModal && (
                <Button type="button" onClick={() => openScheduleModal('schedule16ConnectedPersons', formData.schedule16ConnectedPersons)} variant="secondary" className="my-2 text-sm">
                   {t('open_schedule_button', {schedule_name: t('sch16_2_title')})}
                </Button>
              )}
              <Input
                label={t('s9_3_adjustments_connected_persons_label')}
                type="text"
                id="adjustmentsConnectedPersonsNonMarketValue"
                value={data.adjustmentsConnectedPersonsNonMarketValue}
                readOnly
                className="bg-gray-100"
                error={errors.adjustmentsConnectedPersonsNonMarketValue as string}
                placeholder={t('amount_aed_placeholder')}
              />
            </>
        )}
      </fieldset>

      <fieldset className="p-4 border rounded-md bg-slate-50">
        <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s9_4_qif_title')}</legend>
         <RadioGroup
          label={t('s9_4_investor_in_qif_label')}
          name="investorInQIF"
          value={data.investorInQIF}
          onChange={(val) => onChange('otherAdjustments', 'investorInQIF', val)}
          options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
          error={errors.investorInQIF as string}
          t={t}
        />
        {data.investorInQIF === 'yes' && (
          <>
           <Input
            label={t('s9_4_qif_net_interest_income_label')}
            type="number"
            id="qifNetInterestIncome"
            value={data.qifNetInterestIncome}
            onChange={(e) => onChange('otherAdjustments', 'qifNetInterestIncome', e.target.value)}
            error={errors.qifNetInterestIncome as string}
            placeholder={t('amount_aed_placeholder')}
            helpText={t('s9_4_qif_net_interest_income_help')}
          />
           <Input label={t('s9_4_qif_net_rental_income_label')} type="number" id="qifNetRentalIncome" value={data.qifNetRentalIncome || ''} onChange={e => onChange('otherAdjustments', 'qifNetRentalIncome', e.target.value)} error={errors.qifNetRentalIncome as string} placeholder={t('amount_aed_placeholder')} />
           <Input label={t('s9_4_qif_net_exempt_income_label')} type="number" id="qifNetExemptIncome" value={data.qifNetExemptIncome || ''} onChange={e => onChange('otherAdjustments', 'qifNetExemptIncome', e.target.value)} error={errors.qifNetExemptIncome as string} placeholder={t('amount_aed_placeholder')} />
           <Input label={t('s9_4_qif_other_income_label')} type="number" id="qifOtherIncome" value={data.qifOtherIncome || ''} onChange={e => onChange('otherAdjustments', 'qifOtherIncome', e.target.value)} error={errors.qifOtherIncome as string} placeholder={t('amount_aed_placeholder')} />
           <Input label={t('s9_4_qif_dividends_declared_by_tp_label')} type="number" id="qifDividendsDeclaredByTPFromQIF" value={data.qifDividendsDeclaredByTPFromQIF || ''} onChange={e => onChange('otherAdjustments', 'qifDividendsDeclaredByTPFromQIF', e.target.value)} error={errors.qifDividendsDeclaredByTPFromQIF as string} placeholder={t('amount_aed_placeholder')} />
          </>
        )}
      </fieldset>

       <fieldset className="p-4 border rounded-md bg-slate-50">
        <legend className="text-md font-semibold text-[#1a2c46] px-2">{t('s9_5_other_adjustments_title')}</legend>
        <RadioGroup
          label={t('s9_5_prior_period_error_label')}
          name="priorPeriodErrorCorrectionImpactAED10000OrLess"
          value={data.priorPeriodErrorCorrectionImpactAED10000OrLess}
          onChange={(val) => onChange('otherAdjustments', 'priorPeriodErrorCorrectionImpactAED10000OrLess', val)}
          options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]}
          error={errors.priorPeriodErrorCorrectionImpactAED10000OrLess as string}
          t={t}
        />
        {data.priorPeriodErrorCorrectionImpactAED10000OrLess === 'yes' && (
          <>
            <Select 
                label={t('s9_5_prior_period_error_tax_periods_label')} 
                id="priorPeriodErrorAdjustmentsTaxPeriods" 
                multiple 
                value={data.priorPeriodErrorAdjustmentsTaxPeriods || []}
                onChange={e => handlePriorPeriodTaxPeriodsChange(Array.from(e.target.selectedOptions, option => option.value))}
                options={priorTaxPeriodOptions} 
                error={errors.priorPeriodErrorAdjustmentsTaxPeriods as string}
                helpText={t('s9_5_prior_period_error_tax_periods_help')}
            />
            <Input
                label={t('s9_5_prior_period_error_increase_ti_label')}
                type="number"
                id="priorPeriodErrorAdjustmentsIncreaseTI"
                value={data.priorPeriodErrorAdjustmentsIncreaseTI}
                onChange={(e) => onChange('otherAdjustments', 'priorPeriodErrorAdjustmentsIncreaseTI', e.target.value)}
                error={errors.priorPeriodErrorAdjustmentsIncreaseTI as string}
                placeholder={t('amount_aed_placeholder')}
            />
            <Input
                label={t('s9_5_prior_period_error_decrease_ti_label')}
                type="number"
                id="priorPeriodErrorAdjustmentsDecreaseTI"
                value={data.priorPeriodErrorAdjustmentsDecreaseTI || ''}
                onChange={(e) => onChange('otherAdjustments', 'priorPeriodErrorAdjustmentsDecreaseTI', e.target.value)}
                error={errors.priorPeriodErrorAdjustmentsDecreaseTI as string}
                placeholder={t('amount_aed_placeholder')}
            />
             <Input
                label={t('s9_5_prior_period_error_desc_label')}
                type="text"
                id="priorPeriodErrorAdjustmentsDesc"
                value={data.priorPeriodErrorAdjustmentsDesc || ''}
                onChange={(e) => onChange('otherAdjustments', 'priorPeriodErrorAdjustmentsDesc', e.target.value)}
                error={errors.priorPeriodErrorAdjustmentsDesc as string}
                placeholder={t('s9_5_prior_period_error_desc_placeholder')}
            />
          </>
        )}
        <RadioGroup label={t('s9_5_other_adjustments_not_captured_label')} name="otherAdjustmentsNotCapturedAbove" value={data.otherAdjustmentsNotCapturedAbove || ''} onChange={(val) => onChange('otherAdjustments', 'otherAdjustmentsNotCapturedAbove', val)} options={[{ label: t('yes'), value: 'yes' }, { label: t('no'), value: 'no' }]} t={t} error={errors.otherAdjustmentsNotCapturedAbove as string} />
        {data.otherAdjustmentsNotCapturedAbove === 'yes' && (
          <>
            <Input label={t('s9_5_other_adjustments_increase_ti_label')} type="number" id="otherAdjustmentsNotCapturedIncreaseTI" value={data.otherAdjustmentsNotCapturedIncreaseTI || ''} onChange={e => onChange('otherAdjustments', 'otherAdjustmentsNotCapturedIncreaseTI', e.target.value)} error={errors.otherAdjustmentsNotCapturedIncreaseTI as string} />
            <Input label={t('s9_5_other_adjustments_decrease_ti_label')} type="number" id="otherAdjustmentsNotCapturedDecreaseTI" value={data.otherAdjustmentsNotCapturedDecreaseTI || ''} onChange={e => onChange('otherAdjustments', 'otherAdjustmentsNotCapturedDecreaseTI', e.target.value)} error={errors.otherAdjustmentsNotCapturedDecreaseTI as string} />
            <Input label={t('s9_5_other_adjustments_desc_label')} type="text" id="otherAdjustmentsNotCapturedDesc" value={data.otherAdjustmentsNotCapturedDesc || ''} onChange={e => onChange('otherAdjustments', 'otherAdjustmentsNotCapturedDesc', e.target.value)} error={errors.otherAdjustmentsNotCapturedDesc as string} />
          </>
        )}
      </fieldset>

      <p className="mt-4 text-sm text-gray-600">{t('step6_note')}</p>
      {formData.elections.smallBusinessRelief && (
         <p className="mt-2 p-3 bg-yellow-50 border border-yellow-200 text-yellow-700 rounded-md text-sm">
           {t('sbr_skip_note')}
         </p>
      )}
    </div>
  );
};